export enum DataFileStatus {
  Abandoned = 'Abandoned',
  ClientReviewRequired = 'Client Review Required',
  Error = 'Error',
  InParsing = 'In Parsing',
  InProcessing = 'In Processing',
  ManualProcessingRequired = 'Manual Processing Required',
  Parsed = 'Parsed',
  Pending = 'Pending',
  Processed = 'Processed',
  Split = 'Split',
}
